module.exports = __webpack_public_path__ + "static/img/1.39bcbd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/1.png
// module id = pvAd
// module chunks = 0